module.exports = __webpack_public_path__ + "static/winner-3a3afdd3c0b765b64fd85c2c02e65924.mp3";